import React, { createContext, useContext, useLayoutEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { reportKeys } from '@/services/api/reportsV2';
import { useWorkspace } from './WorkspaceContext';

const ReportWorkspaceContext = createContext('');

export const ReportWorkspaceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const client = useQueryClient();
  const { currentWorkspace } = useWorkspace();
  const requestedWorkspaceId = currentWorkspace?.id ?? '';
  const previousWorkspaceId = useRef(requestedWorkspaceId);
  const [readyWorkspaceId, setReadyWorkspaceId] = useState(requestedWorkspaceId);

  useLayoutEffect(() => {
    const previous = previousWorkspaceId.current;
    if (previous && previous !== requestedWorkspaceId) {
      client.removeQueries({ queryKey: reportKeys.root(previous) });
    }
    previousWorkspaceId.current = requestedWorkspaceId;
    setReadyWorkspaceId(requestedWorkspaceId);
  }, [client, requestedWorkspaceId]);

  const workspaceId = readyWorkspaceId === requestedWorkspaceId ? requestedWorkspaceId : '';
  return <ReportWorkspaceContext.Provider value={workspaceId}>{children}</ReportWorkspaceContext.Provider>;
};

export const useReportWorkspace = (): string => useContext(ReportWorkspaceContext);
